import React, { useEffect } from "react";
import { Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/Loading/Loader";
import {
  orderdata_updateGroupOrderForDay,
  orderdata_saveOrderToSAP
} from "reducers/orderdata/orderdata";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { appdataSelector, appdata_setSnackbar } from "reducers/appdata/appdata";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3
};

function GroupOrdersDayMenu(props) {
  //console.log("GroupOrdersDayMenu -", props);
  const dispatch = useDispatch();
  const appdata = useSelector(appdataSelector);
  const [open, setOpen] = React.useState(false);
  const [allergiesForMenu, setAllergiesForMenu] = React.useState({});
  let dayDisabled = props.disabled;
  let orderValid = false;

  // if cost center or project are set, the order has been created in SAP
  if (props.order.COST_CENTER && props.order.COST_CENTER != "") {
    orderValid = true;
  }
  if (props.order.PROJECT && props.order.PROJECT != "00000000") {
    orderValid = true;
  }

  useEffect(() => {
    if (!props.order.BLDG_LOC && !props.allowLocation) {
      changeValue("BLDG_LOC", "1000");
    }
  }, []);

  const handleAllergieClick = params => {
    console.log("allergie clicked", params.allergies, props);
    let allergiesForMenu = [];
    let split = params.allergies.split(",");
    console.log("split", split);
    Object.keys(split).map(key => {
      console.log("key", key);
      allergiesForMenu[split[key]] =
        props.allergies[split[key]]["ALGEN_" + appdata.language];
    });
    setAllergiesForMenu(allergiesForMenu);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const changeValue = (key, value) => {
    let toUpdate = {
      id: props.id,
      weeknumber: props.weeknumber,
      date: props.date,
      values: { [key]: value }
    };
    dispatch(orderdata_updateGroupOrderForDay(toUpdate));
  };

  const handleSave = (cancel = false) => {
    console.log("handle save, cancel: ", cancel, props.order);

    let keys = Object.keys(props.order);
    if (!keys.includes("MENU1") && !keys.includes("MENU2") && !keys.includes("MENU3")) {
      dispatch(appdata_setSnackbar({ open: true, message: "Please enter an order amount", severity: "error" }))
      return;
    }

    let amount = 0;
    amount += keys.includes("MENU1") ? parseInt(props.order.MENU1) : 0;
    amount += keys.includes("MENU2") ? parseInt(props.order.MENU2) : 0;
    amount += keys.includes("MENU3") ? parseInt(props.order.MENU3) : 0;

    console.log("handle save, amount", amount);

    if (amount == 0 && !cancel) {
      console.log("handle save no menu's selected, no amount given");
      dispatch(appdata_setSnackbar({ open: true, message: "Please enter an order amount, or cancel order", severity: "error" }))
      return;
    }

    let vals = { ...props.order };
    if (cancel) {
      vals["CANCEL"] = "X";
    }

    let toSave = {
      id: props.id,
      weeknumber: props.weeknumber,
      date: props.date,
      values: vals,
      group: true
    };

    dispatch(orderdata_saveOrderToSAP(toSave));
  };

  return (
    <React.Fragment>
      <Grid
        id={!props.order.savedToSap ? "newGroupOrder" : ""}
        key={"GRID"}
        item
        xs={12}
        sx={{
          marginBottom: "20px",
          padding: "10px 20px 10px 10px",
          border:
            props.order && !props.order.savedToSap ? "2px solid" : "2px solid",
          borderColor:
            props.order && !props.order.savedToSap
              ? "info.main"
              : dayDisabled
                ? "lightgray"
                : props.order != undefined
                  ? "primary.light"
                  : "warning.light"
        }}
      >
        {!orderValid && (
          <div className="mb-2">
            <b>Add Cost Center or Project / Employee ID </b>
          </div>
        )}
        {/* COST CENTER */}
        {/* COST CENTER */}
        {/* COST CENTER */}
        {/* COST CENTER */}
        {/* COST CENTER */}
        <TextField
          disabled={dayDisabled || props.order.PROJECT ? true : false}
          sx={{ width: { sm: "100%", md: "50%" } }}
          inputProps={{ maxLength: 10 }}
          type="Number"
          className="mt-2"
          id="outlined"
          label="Cost Center"
          onChange={event => {
            changeValue("COST_CENTER", event.target.value ? Math.max(0, parseInt(event.target.value)).toString().slice(0, 10) : null);
          }}
          value={props.order.COST_CENTER ? props.order.COST_CENTER : ""}
        />
        <br></br>
        {/* PROJECT */}
        {/* PROJECT */}
        {/* PROJECT */}
        {/* PROJECT */}
        {/* PROJECT */}
        <TextField
          inputProps={{ maxLength: 24 }}
          disabled={dayDisabled || props.order.COST_CENTER ? true : false}
          sx={{ width: { sm: "100%", md: "50%" } }}
          className="mt-4"
          id="outlined"
          label="Project or Employee ID"
          onChange={event => {
            changeValue("PROJECT", event.target.value.toUpperCase());
          }}
          value={props.order.PROJECT ? props.order.PROJECT : ""}
        />
        <br></br>
        {/* COMPANY */}
        {/* COMPANY */}
        {/* COMPANY */}
        {/* COMPANY */}
        {/* COMPANY */}
        {orderValid && (
          <TextField
            inputProps={{ maxLength: 50 }}
            disabled={dayDisabled}
            sx={{ width: { sm: "100%", md: "50%" } }}
            className="mt-4"
            id="outlined"
            label="Company or Name"
            onChange={event => {
              changeValue("COMPANY", event.target.value);
            }}
            value={props.order.COMPANY ? props.order.COMPANY : ""}
          />
        )}

        {/* no menus are scheduled for this day */}
        {/* no menus are scheduled for this day */}
        {/* no menus are scheduled for this day */}
        {/* no menus are scheduled for this day */}
        {props.menus === undefined && (
          <div className="mt-4">There is no Lunch available for this day</div>
        )}

        {orderValid && props.menus && Object.keys(props.menus).length > 0 && (
          <div className="mt-4">
            {Object.keys(props.menus).map(key => {
              if (key.includes("_NUMB") && parseInt(props.menus[key]) > 0) {
                let menukey = key.substring(0, 5);
                return (
                  <div
                    key={"div" + menukey}
                    className="d-flex align-items-center mb-4"
                  >
                    <TextField
                      disabled={dayDisabled}
                      key={"amount" + menukey}
                      InputProps={{ inputProps: { min: 0 } }}
                      type="Number"
                      className="mr-4"
                      size="small"
                      sx={{ width: "100px" }}
                      id="outlined"
                      label="amount"
                      onChange={event => {
                        changeValue(menukey, event.target.value);
                      }}
                      value={
                        props.order[menukey]
                          ? parseInt(props.order[menukey])
                          : ""
                      }
                    />
                    {
                      props.mappedMenus[parseInt(props.menus[key])][
                      "MENU_" + appdata.language
                      ]
                    }
                    {key == "MENU3_NUMB" && appdata.language == "DE" && " + Salat"}
                    {key == "MENU3_NUMB" && appdata.language == "EN" && " + Salad"}
                    <Link
                      key={"Link" + menukey}
                      component="button"
                      variant="body2"
                      className="ml-2"
                      onClick={() => {
                        console.log("click allergie");
                        handleAllergieClick({
                          allergies:
                            props.mappedMenus[parseInt(props.menus[key])][
                            "MENU_ALGEN"
                            ]
                        });
                      }}
                    >
                      {
                        props.mappedMenus[parseInt(props.menus[key])][
                        "MENU_ALGEN"
                        ]
                      }
                    </Link>
                  </div>
                );
              }
            })}
          </div>
        )}
        {/* location selection */}
        {/* location selection */}
        {/* location selection */}
        {/* location selection */}
        {/* location selection */}
        {orderValid && props.allowLocation &&
          <React.Fragment>
            <div><hr></hr></div>
            <div className="ml-2 mr-2 d-inline">
              <FormControlLabel
                control={
                  <Checkbox
                    key={"checkbox" + "menukey"}
                    checked={props.order.BLDG_LOC == "1000"}
                    onChange={(event) => {
                      if (event.target.checked) {
                        changeValue("BLDG_LOC", "1000")
                      }
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Radfeld"
              />

            </div>


            <div className="ml-5 mr-2 d-inline">
              <FormControlLabel
                control={
                  <Checkbox
                    key={"checkbox" + "menukey"}
                    checked={props.order.BLDG_LOC == "1200"}
                    onChange={(event) => {
                      if (event.target.checked) {
                        changeValue("BLDG_LOC", "1200")
                      }
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Kramsach"
              />

            </div>
          </React.Fragment>
        }

        <div className="mt-4 text-right">
          {!dayDisabled &&
            !props.order.saving &&
            orderValid &&
            props.order.savedToSap && (
              <Button
                color="error"
                variant="outlined"
                onClick={() => {
                  handleSave(true);
                }}
              >
                Cancel order
              </Button>
            )}
          {!dayDisabled && !props.order.saving && orderValid && props.order.BLDG_LOC && (
            <Button
              className="ml-2"
              variant="outlined"
              onClick={() => {
                handleSave();
              }}
            >
              Save order
            </Button>
          )}
          {props.order.saving && orderValid && <Loader w="25" />}
        </div>
      </Grid>

      <Modal
        key={"modal"}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Allergies for this Menu:
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {Object.keys(allergiesForMenu).map(key => {
              return (
                <div>
                  ({key}) : {allergiesForMenu[key]}
                </div>
              );
            })}
          </Typography>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export default GroupOrdersDayMenu;
